import React, { useEffect, useState } from "react";
import currency from "currency.js";
import closeModals from "../util/closeModals";
import { useRedirect } from "../services/hooks/useRedirect";
import ProductButtons from "./ProductButtons";

const StoreProductModal = React.memo(({ product }) => {
  const { redirect } = useRedirect();

  const handleMoreProductInfo = (e) => {
    e.preventDefault();

    const productUrl = e.target.dataset.productUrl;

    if (productUrl) {
      closeModals("#modalProduct");

      redirect(productUrl);
    }
  };

  useEffect(() => {
    return () => {
      closeModals("#modalProduct");
    };
  }, [product]);

  if (!product) {
    return null;
  }

  return (
    <>
      {/* Product */}
      <div
        className="modal fade"
        id="modalProduct"
        tabIndex={-1}
        role="dialog"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            {/* Close */}
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <i className="fe fe-x" aria-hidden="true" />
            </button>
            {/* Content */}
            <div className="container-fluid px-xl-0">
              <div className="row align-items-center mx-xl-0">
                <div className="col-12 col-lg-6 col-xl-5 py-4 py-xl-0 px-xl-0">
                  <div className="d-flex flex-column justify-content-between">
                    {/* Image */}
                    <img
                      src={product.images[0].src}
                      alt={product.name}
                      width="100%"
                    />
                    {/* Button */}
                    <a
                      href="#"
                      className="btn btn-sm btn-block btn-primary"
                      data-product-url={`/products/${
                        product.handle || product.id
                      }`}
                      onClick={handleMoreProductInfo}
                    >
                      More Product Info <i className="fe fe-info ml-2" />
                    </a>
                  </div>
                </div>
                <div className="col-12 col-lg-6 col-xl-7 py-9 px-md-9">
                  {/* Heading */}
                  <h5 className="mb-1 text-uppercase">{product.brand}</h5>
                  <h6 className="mb-3">{product.name}</h6>
                  {/* Price */}
                  <div className="mb-7">
                    {product.compareAtPrice ? (
                      <span className="h6 text-gray-350 text-decoration-line-through">
                        {currency(product.compareAtPrice).format()}
                      </span>
                    ) : (
                      ""
                    )}

                    <span className="h5 text-primary">
                      {currency(product.price).format()}
                    </span>
                  </div>

                  <ProductButtons
                    product={product}
                    showBuyNow={false}
                    showSecureTransactionNotice={false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
});

export default StoreProductModal;
